'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _adapterJs = require('./adapter.js');

exports['default'] = _interopRequire(_adapterJs);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-localstorage/lib/adapters/localStorage/index.js
// module id = 297
// module chunks = 53